import { type FC } from 'react';
import { ProductAttributeInterface } from '../../../../../../../Interface/ProductAttribute';
import ZoomImage from '../../../../../ProductSize/ProductSizeImage/ProductImage/ZoomImage/ZoomImage';
import styles from './AttributeImg.module.scss?module';
import depositImage from '../../../../../../../../public/images/pfand_img.webp';

type AttributeImgPropsT = {
  img: ProductAttributeInterface['image_white_public_url'];
  name: ProductAttributeInterface['name'];
  onClick?: () => void;
  isNew?: boolean;
  imageOverlayUri?: string;
  isDeposit?: boolean;
};

const AttributeImg: FC<AttributeImgPropsT> = ({
  img,
  name,
  onClick,
  isNew,
  imageOverlayUri,
  isDeposit,
}) => {
  if (!!img)
    return (
      <div className="position-relative" onClick={onClick}>
        <ZoomImage src={img} alt={`product-${name}-image`} />
        {isNew ? <div className={styles.new}>NEW!</div> : null}
        {imageOverlayUri ? (
          <img
            className={styles.overlayImage}
            src={imageOverlayUri}
            alt={`${name}-overlay`}
          />
        ) : null}
        {isDeposit ? (
          <div className={styles.deposit}>
            <img src={depositImage} alt="deposit_image" />
          </div>
        ) : null}
      </div>
    );

  return null;
};

export default AttributeImg;
